var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Выберите склад")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedStore,
                        expression: "selectedStore",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedStore = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "optgroup",
                      { attrs: { label: "---" } },
                      _vm._l(
                        _vm
                          .getSortedStores()
                          .filter((s) => ![3, 10, 30].includes(s.id)),
                        function (s) {
                          return _c("option", { domProps: { value: s.id } }, [
                            _vm._v(_vm._s(s.title) + "\n                "),
                          ])
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8" }, [
              _c(
                "div",
                { staticClass: "form-group mb-0" },
                [
                  _c("label", [_vm._v("Выберите препарат")]),
                  _vm._v(" "),
                  _c("DrugSearchNew", {
                    ref: "searchDrug",
                    attrs: {
                      searchOptions: { inStores: true, prices: true },
                      onSelect: (d) => _vm.selectDrug(d),
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _vm.selectedDrugs.length
                  ? [
                      _c(
                        "table",
                        { staticClass: "table mt-0 table-sm table-hover" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.selectedDrugs, function (d) {
                              return _c("tr", [
                                _c("td", [_vm._v(_vm._s(d.id))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(d.title))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.getStoreQty(d)))]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newStoreQty[d.id],
                                        expression: "newStoreQty[d.id]",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "number" },
                                    domProps: { value: _vm.newStoreQty[d.id] },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.newStoreQty,
                                          d.id,
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-danger",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeDrug(d.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-remove",
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1 text-right" },
                        [
                          _c("LoadingButton", {
                            attrs: {
                              title: "Поиск вариантов",
                              loading: _vm.loading,
                              type: "button",
                              color: _vm.$constants.SUCCESS_COLOR,
                              onClick: () => _vm.searchOrders(),
                              className: "btn btn-outline-success",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: {
          loading: _vm.updateLoading,
          color: _vm.$constants.LOADING_COLOR,
        },
      }),
      _vm._v(" "),
      (_vm.orders.length || Object.keys(_vm.extraOrders).length) &&
      !_vm.updateLoading
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("table", { staticClass: "table table-hover table-sm mt-0" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.orders, function (o) {
                      return [
                        _c("CorrectionOrderTr", {
                          attrs: {
                            o: o,
                            "orders-changes": _vm.ordersChanges,
                            "update-orders": _vm.updateOrders,
                          },
                        }),
                      ]
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.extraOrders, function (orders, divId) {
                      return [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "bg-warning",
                              attrs: { colspan: "15" },
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$AllDivisions[divId].title)),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(orders, function (o) {
                          return _c("CorrectionOrderTr", {
                            key: o.id,
                            attrs: {
                              o: o,
                              "orders-changes": _vm.ordersChanges,
                              "update-orders": _vm.updateOrders,
                            },
                          })
                        }),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("optgroup", { attrs: { label: "---" } }, [
      _c("option", { attrs: { value: "3" } }, [_vm._v("Москва")]),
      _vm._v(" "),
      _c("option", { attrs: { value: "10" } }, [_vm._v("СПБ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
        _vm._v(" "),
        _c("th", [_vm._v("Новое количество")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", [_vm._v("Фин.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Изменения")]),
        _vm._v(" "),
        _c("th", [_vm._v("Н.Фин")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }